import { Box, useTheme } from '@mui/material';
import { FormikErrors } from 'formik';
import { DevOnlyFeature } from '../../../commonUI/viewMode/DevOnlyFeature';
import useFormStyles from '../hooks/useFormStyles';
import FormikErrorDisplay from './FormikErrorDisplay';
import OnboardFormHeader from './OnboardFormHeader';

interface Props {
  children: React.ReactNode;
  onSubmit: () => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  formikErrors?: FormikErrors<any>;
}

const OnboardFormLayout: React.FC<Props> = ({
  children,
  onSubmit,
  formikErrors,
}) => {
  const theme = useTheme();
  const { commonFormSectionStyles } = useFormStyles();

  return (
    <Box
      sx={{
        width: '100%',
        p: '2rem',
        bgcolor: theme.colors.darkTheme.grey.dark,
        border: `1px solid ${theme.colors.darkTheme.grey.muted}`,
        borderRadius: theme.borderRadius.primary,
        boxShadow:
          '0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)',
        display: 'grid',
        gridTemplateColumns: '1fr',
        gridTemplateRows: 'min-content 1fr',
      }}
      onSubmit={onSubmit}
    >
      <Box sx={{ ...commonFormSectionStyles, mb: '1rem' }}>
        <OnboardFormHeader />
      </Box>
      <Box
        sx={{
          ...commonFormSectionStyles,
          flexDirection: 'column',
          gap: '1rem',
        }}
      >
        {children}
      </Box>
      <DevOnlyFeature>
        <FormikErrorDisplay formikErrors={formikErrors} />
      </DevOnlyFeature>
    </Box>
  );
};

export default OnboardFormLayout;
